import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'

const StyledToggleVisibility = styled.button`
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  color: var(--gameday-buttons-iconColor, ${theme.buttons.iconColor});
  cursor: pointer;

  ${props =>
    props.isInline &&
    css`
      flex-direction: row-reverse;
    `}

  &:focus {
    outline: 0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
`

const StyledIcon = styled.svg`
  display: block;
  width: ${rem(21)};
  height: ${rem(19)};
  fill: currentColor;
  margin-bottom: ${rem(-4)};
`

const StyledLabel = styled.span`
  font-size: ${theme.typography.fontSizeTinyish};
  font-weight: ${theme.typography.fontWeightBolder};

  ${props =>
    props.isInline &&
    css`
      font-size: ${theme.typography.fontSizeTiny};
      line-height: 1;
      padding: 0 ${rem(5)};
    `}
`

function ToggleVisibility({ isVisible, disabled, visibleLabel, notVisibleLabel, onToggle, inline }) {
  const handleToggle = e => {
    e.stopPropagation()
    onToggle()
  }

  return (
    <StyledToggleVisibility onClick={handleToggle} disabled={disabled} isInline={inline}>
      <StyledIcon viewBox="0 0 21 19">
        <path d="M20.739 8.62C18.205 5.047 14.47 3 10.5 3 6.53 3 2.795 5.048.261 8.62L0 9.012l.261.368C2.795 12.95 6.53 15 10.5 15c3.97 0 7.705-2.048 10.239-5.62L21 8.988l-.261-.368zM10.5 13.66c-2.56 0-4.623-2.074-4.623-4.647 0-2.573 2.063-4.648 4.623-4.648s4.623 2.075 4.623 4.648c0 2.573-2.063 4.648-4.623 4.648zM1.62 9.014C2.768 7.49 4.18 6.31 5.72 5.521a5.985 5.985 0 00-1.123 3.492c0 1.287.418 2.52 1.123 3.492-1.567-.787-2.951-1.969-4.1-3.492zm13.686 3.492a5.985 5.985 0 001.123-3.492c0-1.287-.418-2.52-1.123-3.492 1.541.788 2.925 1.995 4.1 3.492-1.175 1.523-2.559 2.705-4.1 3.492z" />
        {!isVisible && <rect x="18" width="1.563" height="24.307" rx=".781" transform="rotate(45 18 0)" />}
      </StyledIcon>
      <StyledLabel isInline={inline}>{isVisible ? visibleLabel : notVisibleLabel}</StyledLabel>
    </StyledToggleVisibility>
  )
}

ToggleVisibility.defaultProps = {
  visibleLabel: 'Visible',
  notVisibleLabel: 'Hidden',
  onToggle: () => {},
  inline: false,
}

export default ToggleVisibility
